var map = {
	"./gallery1.jpg": 66,
	"./gallery10.jpg": 67,
	"./gallery11.jpg": 68,
	"./gallery12.jpg": 69,
	"./gallery13.jpg": 70,
	"./gallery14.jpg": 71,
	"./gallery15.jpg": 72,
	"./gallery2.jpg": 73,
	"./gallery3.jpg": 74,
	"./gallery4.jpg": 75,
	"./gallery5.jpg": 76,
	"./gallery6.jpg": 77,
	"./gallery7.jpg": 78,
	"./gallery8.jpg": 79,
	"./gallery9.jpg": 80
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65;